import { Box, Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { ClientPortalUser } from '../types';
import { CLIENT_PORTAL_USER_STATUSES } from 'domain/shared/clientPortal';

type AssigneeNameFieldProps = FieldProps & {
  clients?: ClientPortalUser[];
  isTooltipVisible?: boolean;
};

const getClientName = (client: ClientPortalUser) => client.name || `${client.firstName} ${client.lastName}`.trim();

const AssigneeNameField = ({
  source = 'assigneeExternalUserId',
  clients = [],
  isTooltipVisible = false,
}: AssigneeNameFieldProps) => {
  const { getValue } = useFieldHelper<string>({ source });
  const assigneeExternalUserId = getValue();
  const assignee = clients.find(
    client => client.externalId === assigneeExternalUserId || client.id === assigneeExternalUserId,
  );
  const assigneeName = assignee ? getClientName(assignee) : EMPTY_VALUE_INDICATOR;

  const isAssigneeInactive = assignee?.status === CLIENT_PORTAL_USER_STATUSES.INACTIVE;
  const field = <Typography color={isAssigneeInactive ? 'text.disabled' : 'text.primary'}>{assigneeName}</Typography>;

  if (!isTooltipVisible) {
    return field;
  }

  return (
    <Tooltip title={'Assignee'} placement={'left'}>
      <Box>{field}</Box>
    </Tooltip>
  );
};

export default AssigneeNameField;
